export default ({ route, store, error }) => {
  const types = store.getters['fees/types']
  const requestedType = route.params.feeType

  if (!hasType(requestedType)) {
    return error({ statusCode: 404 })
  }

  function hasType (typeValue) {
    return types.some(type => type.value === typeValue)
  }
}
